import { MessageType, UnknownFieldHandler, WireType, reflectionMergePartial } from "@protobuf-ts/runtime";
// src/newsdoc/newsdoc.ts
var Document$Type = class extends MessageType {
	constructor() {
		super("newsdoc.Document", [
			{
				no: 1,
				name: "uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "type",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "uri",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "url",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "title",
				kind: "scalar",
				T: 9
			},
			{
				no: 6,
				name: "content",
				kind: "message",
				repeat: 2,
				T: () => Block
			},
			{
				no: 7,
				name: "meta",
				kind: "message",
				repeat: 2,
				T: () => Block
			},
			{
				no: 8,
				name: "links",
				kind: "message",
				repeat: 2,
				T: () => Block
			},
			{
				no: 9,
				name: "language",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.uuid = "";
		message.type = "";
		message.uri = "";
		message.url = "";
		message.title = "";
		message.content = [];
		message.meta = [];
		message.links = [];
		message.language = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.uuid = reader.string();
					break;
				case 2:
					message.type = reader.string();
					break;
				case 3:
					message.uri = reader.string();
					break;
				case 4:
					message.url = reader.string();
					break;
				case 5:
					message.title = reader.string();
					break;
				case 6:
					message.content.push(Block.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 7:
					message.meta.push(Block.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 8:
					message.links.push(Block.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 9:
					message.language = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	internalBinaryWrite(message, writer, options) {
		if (message.uuid !== "") writer.tag(1, WireType.LengthDelimited).string(message.uuid);
		if (message.type !== "") writer.tag(2, WireType.LengthDelimited).string(message.type);
		if (message.uri !== "") writer.tag(3, WireType.LengthDelimited).string(message.uri);
		if (message.url !== "") writer.tag(4, WireType.LengthDelimited).string(message.url);
		if (message.title !== "") writer.tag(5, WireType.LengthDelimited).string(message.title);
		for (let i = 0; i < message.content.length; i++) Block.internalBinaryWrite(message.content[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.meta.length; i++) Block.internalBinaryWrite(message.meta[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.links.length; i++) Block.internalBinaryWrite(message.links[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
		if (message.language !== "") writer.tag(9, WireType.LengthDelimited).string(message.language);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message newsdoc.Document
*/
const Document = new Document$Type();
var Block$Type = class extends MessageType {
	constructor() {
		super("newsdoc.Block", [
			{
				no: 1,
				name: "id",
				kind: "scalar",
				T: 9
			},
			{
				no: 2,
				name: "uuid",
				kind: "scalar",
				T: 9
			},
			{
				no: 3,
				name: "uri",
				kind: "scalar",
				T: 9
			},
			{
				no: 4,
				name: "url",
				kind: "scalar",
				T: 9
			},
			{
				no: 5,
				name: "type",
				kind: "scalar",
				T: 9
			},
			{
				no: 6,
				name: "title",
				kind: "scalar",
				T: 9
			},
			{
				no: 7,
				name: "data",
				kind: "map",
				K: 9,
				V: {
					kind: "scalar",
					T: 9
				}
			},
			{
				no: 8,
				name: "rel",
				kind: "scalar",
				T: 9
			},
			{
				no: 9,
				name: "role",
				kind: "scalar",
				T: 9
			},
			{
				no: 10,
				name: "name",
				kind: "scalar",
				T: 9
			},
			{
				no: 11,
				name: "value",
				kind: "scalar",
				T: 9
			},
			{
				no: 12,
				name: "contenttype",
				kind: "scalar",
				T: 9
			},
			{
				no: 13,
				name: "links",
				kind: "message",
				repeat: 2,
				T: () => Block
			},
			{
				no: 14,
				name: "content",
				kind: "message",
				repeat: 2,
				T: () => Block
			},
			{
				no: 15,
				name: "meta",
				kind: "message",
				repeat: 2,
				T: () => Block
			},
			{
				no: 16,
				name: "sensitivity",
				kind: "scalar",
				T: 9
			}
		]);
	}
	create(value) {
		const message = globalThis.Object.create(this.messagePrototype);
		message.id = "";
		message.uuid = "";
		message.uri = "";
		message.url = "";
		message.type = "";
		message.title = "";
		message.data = {};
		message.rel = "";
		message.role = "";
		message.name = "";
		message.value = "";
		message.contenttype = "";
		message.links = [];
		message.content = [];
		message.meta = [];
		message.sensitivity = "";
		if (value !== void 0) reflectionMergePartial(this, message, value);
		return message;
	}
	internalBinaryRead(reader, length, options, target) {
		let message = target ?? this.create(), end = reader.pos + length;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					message.id = reader.string();
					break;
				case 2:
					message.uuid = reader.string();
					break;
				case 3:
					message.uri = reader.string();
					break;
				case 4:
					message.url = reader.string();
					break;
				case 5:
					message.type = reader.string();
					break;
				case 6:
					message.title = reader.string();
					break;
				case 7:
					this.binaryReadMap7(message.data, reader, options);
					break;
				case 8:
					message.rel = reader.string();
					break;
				case 9:
					message.role = reader.string();
					break;
				case 10:
					message.name = reader.string();
					break;
				case 11:
					message.value = reader.string();
					break;
				case 12:
					message.contenttype = reader.string();
					break;
				case 13:
					message.links.push(Block.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 14:
					message.content.push(Block.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 15:
					message.meta.push(Block.internalBinaryRead(reader, reader.uint32(), options));
					break;
				case 16:
					message.sensitivity = reader.string();
					break;
				default:
					let u = options.readUnknownField;
					if (u === "throw") throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
					let d = reader.skip(wireType);
					if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
			}
		}
		return message;
	}
	binaryReadMap7(map, reader, options) {
		let len = reader.uint32(), end = reader.pos + len, key, val;
		while (reader.pos < end) {
			let [fieldNo, wireType] = reader.tag();
			switch (fieldNo) {
				case 1:
					key = reader.string();
					break;
				case 2:
					val = reader.string();
					break;
				default: throw new globalThis.Error("unknown map entry field for newsdoc.Block.data");
			}
		}
		map[key ?? ""] = val ?? "";
	}
	internalBinaryWrite(message, writer, options) {
		if (message.id !== "") writer.tag(1, WireType.LengthDelimited).string(message.id);
		if (message.uuid !== "") writer.tag(2, WireType.LengthDelimited).string(message.uuid);
		if (message.uri !== "") writer.tag(3, WireType.LengthDelimited).string(message.uri);
		if (message.url !== "") writer.tag(4, WireType.LengthDelimited).string(message.url);
		if (message.type !== "") writer.tag(5, WireType.LengthDelimited).string(message.type);
		if (message.title !== "") writer.tag(6, WireType.LengthDelimited).string(message.title);
		for (let k of globalThis.Object.keys(message.data)) writer.tag(7, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.data[k]).join();
		if (message.rel !== "") writer.tag(8, WireType.LengthDelimited).string(message.rel);
		if (message.role !== "") writer.tag(9, WireType.LengthDelimited).string(message.role);
		if (message.name !== "") writer.tag(10, WireType.LengthDelimited).string(message.name);
		if (message.value !== "") writer.tag(11, WireType.LengthDelimited).string(message.value);
		if (message.contenttype !== "") writer.tag(12, WireType.LengthDelimited).string(message.contenttype);
		for (let i = 0; i < message.links.length; i++) Block.internalBinaryWrite(message.links[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.content.length; i++) Block.internalBinaryWrite(message.content[i], writer.tag(14, WireType.LengthDelimited).fork(), options).join();
		for (let i = 0; i < message.meta.length; i++) Block.internalBinaryWrite(message.meta[i], writer.tag(15, WireType.LengthDelimited).fork(), options).join();
		if (message.sensitivity !== "") writer.tag(16, WireType.LengthDelimited).string(message.sensitivity);
		let u = options.writeUnknownFields;
		if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
		return writer;
	}
};
/**
* @generated MessageType for protobuf message newsdoc.Block
*/
const Block = new Block$Type();
export { Block, Document };
